import { render, staticRenderFns } from "./finalPrice.vue?vue&type=template&id=17cda04e&scoped=true"
import script from "./finalPrice.vue?vue&type=script&lang=js"
export * from "./finalPrice.vue?vue&type=script&lang=js"
import style0 from "./finalPrice.vue?vue&type=style&index=0&id=17cda04e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cda04e",
  null
  
)

export default component.exports